import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Instagram } from 'lucide-react';
import { companyInfo } from '../mockData';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-gray-900 via-slate-900 to-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex items-center">
              <img 
                src="/vigyan-logo.png" 
                alt="Vigyan Logo" 
                className="h-14 w-auto"
              />
            </div>
            <p className="text-sm text-gray-400 leading-relaxed">
              Leading manufacturer of paddy processing plants and machines with next-gen automation technology.
            </p>
            <div className="flex space-x-3 pt-2">
              <a href={companyInfo.facebook} target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-brand-600 transition-colors">
                <Facebook size={18} />
              </a>
              <a href={companyInfo.instagram} target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-brand-600 transition-colors">
                <Instagram size={18} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4 text-lg">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-gray-400 hover:text-brand-400 transition-colors text-sm">Home</Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-brand-400 transition-colors text-sm">About Us</Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-brand-400 transition-colors text-sm">Contact</Link>
              </li>
              <li>
                <a href="#machines" className="text-gray-400 hover:text-brand-400 transition-colors text-sm">Products</a>
              </li>
            </ul>
          </div>

          {/* Products */}
          <div>
            <h4 className="text-white font-semibold mb-4 text-lg">Our Products</h4>
            <ul className="space-y-3">
              <li className="text-gray-400 text-sm">Automated Cooker Plants</li>
              <li className="text-gray-400 text-sm">Steam Plants</li>
              <li className="text-gray-400 text-sm">Drying Systems</li>
              <li className="text-gray-400 text-sm">Pre-Cleaners</li>
              <li className="text-gray-400 text-sm">Dust Collectors</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-semibold mb-4 text-lg">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <Phone size={18} className="text-brand-400 mt-1 flex-shrink-0" />
                <a href={`tel:${companyInfo.phone}`} className="text-sm text-gray-400 hover:text-brand-400 transition-colors">{companyInfo.phone}</a>
              </li>
              <li className="flex items-start space-x-3">
                <Mail size={18} className="text-brand-400 mt-1 flex-shrink-0" />
                <a href={`mailto:${companyInfo.email}`} className="text-sm text-gray-400 hover:text-brand-400 transition-colors">{companyInfo.email}</a>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin size={18} className="text-brand-400 mt-1 flex-shrink-0" />
                <span className="text-sm text-gray-400">{companyInfo.address}</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-gray-500">
              © {new Date().getFullYear()} Vigyan - Vaibhav Vigyan India Pvt. Ltd. All rights reserved.
            </p>
            <div className="flex items-center space-x-4">
              <span className="text-xs text-gray-500 px-3 py-1 bg-gray-800 rounded-full">Made in India</span>
              <span className="text-xs text-gray-500 px-3 py-1 bg-gray-800 rounded-full">ISO Certified</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;